'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/panel-aside.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _reduxWindow = require('redux-window');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _panel = require('./panel');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _componentThemes$pane = _themes.componentThemes.panel,
  panelStyle = _componentThemes$pane.panelStyle,
  panelTheme = _componentThemes$pane.panelTheme,
  panelVariants = _componentThemes$pane.panelVariants;
var helpTextStyle = _themes.componentThemes.helpInfo.helpTextStyle;
var panelAsideWrapperStyles = function panelAsideWrapperStyles(props) {
  var theme = panelTheme(props.theme);
  return Object.assign({}, (0, _panel.panelStyles)(props), _defineProperty({}, (0, _themes.atLeast)(theme.breakpoint_sm), {
    padding: '0 35% 0 0',
    backgroundColor: theme[panelStyle('backgroundColor', panelVariants.aside)]
  }));
};
var panelIndentStyles = function panelIndentStyles(props) {
  return _defineProperty({}, (0, _themes.atLeast)(props.theme.breakpoint_sm), {
    paddingLeft: '10%'
  });
};
var panelAsideStyles = function panelAsideStyles(props) {
  var _ref2;
  var theme = panelTheme(props.theme);
  return _ref2 = {}, _defineProperty(_ref2, (0, _themes.atLeast)(theme.breakpoint_sm), {
    margin: 0,
    borderRightWidth: theme[panelStyle('borderWidth')],
    borderRightStyle: theme[panelStyle('borderStyle')],
    borderRightColor: theme[panelStyle('borderColor')],
    borderRadius: theme[panelStyle('borderRadius')],
    backgroundColor: theme[panelStyle('backgroundColor')],
    padding: theme.space_sm
  }), _defineProperty(_ref2, (0, _themes.atLeast)(theme.breakpoint_md), {
    padding: theme.space_md
  }), _ref2;
};
var helpTextTheme = function helpTextTheme(theme, width) {
  var setWidth = function setWidth() {
    if (width >= theme.breakpoint_lg) {
      return '34.95rem';
    }
    if (width >= theme.breakpoint_md) {
      return '27.67rem';
    }
    return '22.8rem';
  };
  var setLeft = function setLeft() {
    if (width >= theme.breakpoint_md) {
      return theme.space_lg;
    }
    return theme.space_md;
  };
  if (width >= theme.breakpoint_sm) {
    var _ref3;
    return _ref3 = {}, _defineProperty(_ref3, helpTextStyle('position'), 'absolute'), _defineProperty(_ref3, helpTextStyle('left'), '100%'), _defineProperty(_ref3, helpTextStyle('marginBottom'), 0), _defineProperty(_ref3, helpTextStyle('top'), 0), _defineProperty(_ref3, helpTextStyle('marginleft'), setLeft()), _defineProperty(_ref3, helpTextStyle('width'), setWidth()), _ref3;
  }
  return {};
};
PanelAside.propTypes = {
  children: _propTypes.node,
  title: _propTypes.string,
  theme: _propTypes.object.isRequired,
  width: _propTypes.number.isRequired
};
PanelAside.defaultProps = {
  children: null,
  title: null
};
var Wrapper = (0, _glamorous2.default)('div')(panelAsideWrapperStyles);
var Panel = (0, _glamorous2.default)('div')(panelAsideStyles);
var Indent = (0, _glamorous2.default)('div')(panelIndentStyles);
function PanelAside(props) {
  var title = props.title,
    children = props.children,
    rest = _objectWithoutProperties(props, ['title', 'children']);
  return _react2.default.createElement(Wrapper, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95
    },
    __self: this
  }), _react2.default.createElement(_glamorous.ThemeProvider, {
    theme: helpTextTheme(props.theme, props.width),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96
    },
    __self: this
  }, _react2.default.createElement(Panel, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97
    },
    __self: this
  }, title ? _react2.default.createElement(_react.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99
    },
    __self: this
  }, _react2.default.createElement('h2', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100
    },
    __self: this
  }, title), _react2.default.createElement(Indent, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101
    },
    __self: this
  }, children)) : _react2.default.createElement(_react.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104
    },
    __self: this
  }, children))));
}
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    width: (0, _reduxWindow.getWidth)(state)
  };
})((0, _glamorous.withTheme)(PanelAside));